import { render, staticRenderFns } from "./hold.vue?vue&type=template&id=086495cb&scoped=true"
import script from "./hold.vue?vue&type=script&lang=js"
export * from "./hold.vue?vue&type=script&lang=js"
import style0 from "./hold.vue?vue&type=style&index=0&id=086495cb&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086495cb",
  null
  
)

export default component.exports